import { BuiltinModuleTag } from "@scayla/api-client-fetch";
import type { IconName } from "@scayla/components";

import { $t } from "@/i18n";

export const BUILTIN_MODULE_SORT_ORDER = [
  BuiltinModuleTag.EMAILS,
  BuiltinModuleTag.CONTACTS,
  BuiltinModuleTag.DOCUMENTS,
  BuiltinModuleTag.FILES,
  BuiltinModuleTag.PROJECTS,
  BuiltinModuleTag.ASSETS,
  BuiltinModuleTag.ACCOUNTING,
  BuiltinModuleTag.PRODUCTS,
];

export function getModuleIcon(tag?: BuiltinModuleTag): IconName | undefined {
  switch (tag) {
    case BuiltinModuleTag.DOCUMENTS:
      return "generic/dossier-module";
    case BuiltinModuleTag.CONTACTS:
      return "phosphor/users";
    case BuiltinModuleTag.PROJECTS:
      return "phosphor/suitcase-simple";
    case BuiltinModuleTag.ASSETS:
      return "phosphor/chart-line";
    case BuiltinModuleTag.EMAILS:
      return "phosphor/envelope";
    case BuiltinModuleTag.FILES:
      return "phosphor/paperclip";
    case BuiltinModuleTag.ACCOUNTING:
      return "phosphor/calculator";
    case BuiltinModuleTag.SETTINGS_ACCOUNTING:
      return "phosphor/gear";
    case BuiltinModuleTag.PRODUCTS:
      return "phosphor/barcode";
    default:
      return undefined;
  }
}

export function canCreateRecordsByModuleTag(tag?: BuiltinModuleTag): boolean {
  if (!tag) return true;

  return tag !== BuiltinModuleTag.FILES;
}

/** What the module calls a template's kind ("Dossier art", "Project art", ...). */
export function getModuleArtLabel(tag?: BuiltinModuleTag): string {
  if (tag === BuiltinModuleTag.PROJECTS) return $t("common.label.projectArt");
  if (tag === BuiltinModuleTag.ASSETS) return $t("common.label.assetArt");
  if (tag === BuiltinModuleTag.PRODUCTS) return $t("common.label.productArt");
  return $t("common.label.dossierArt");
}
